<template>
	<page enable-flex style="background: #fff;">
		<scan ref="scan" :disabled="!!id" @scan="codeHandle">
			<div class="head">
				<h5>{{codeInfo.name || '-'}}</h5>
				<p>背贴码：{{codeInfo.code || '-'}}</p>
			</div>

			<c-form ref="form">
				<c-form-item label="维修项（可多选）" required>
					<c-checkbox-group v-model="currentItemValue" name="items" :options="itemList"></c-checkbox-group>
				</c-form-item>
				<c-form-item v-for="item in currentItemData" :key="item.value" :label="`（${item.name}）维修金额`" required>
					<c-input v-model="itemSum[item.value]" type="number" :name="`item${item.value}`" decimal="2" append-text="元"></c-input>
				</c-form-item>
				<c-form-item label="备注">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
			</c-form>
		</scan>

		<template v-if="codeInfo.name" #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			id: [String, Number],
			/**背贴码，由商品列表（门店版无维修工作台）带入，用于预填商品、免重复扫码*/
			code: [String, Number]
		},

		data() {
			return {
				codeInfo: {},
				itemList: [],
				currentItemValue: [],
				itemSum: {}
			}
		},

		computed: {
			currentItemData() {
				return this.itemList.filter(item => this.currentItemValue.some(val => val == item.value));
			}
		},

		async mounted() {
			await this.request({
				url: '/system/dic/options',
				data: {
					dic_type_code: 'REPAIR_ITEM'
				},
				success: data => {
					this.itemList = data;
				}
			});

			if (this.id) {
				this.request({
					url: '/repair/record/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.codeHandle(data.info.produce_unique_code);
						this.$refs.form.set({
							items: data.details.map(item => item.repair_item),
							remark: data.info.remark
						});
						this.$nextTick(() => {
							let json = {}
							data.details.forEach(item => {
								json[`item${item.repair_item}`] = item.repair_amount
							});
							this.$refs.form.set(json);
						})
					}
				});
			} else if (this.code) {
				/**带码进来先预填商品（编辑态本就不允许换商品，不作预填）；不带码的扫码入口行为与之前一致*/
				this.codeHandle(this.code);
			}
		},
		
		methods: {
			codeHandle(code) {
				this.request({
					url: '/repair/product/queryByCode',
					data: {
						produce_unique_code: code
					},
					success: data => {
						this.codeInfo = {
							id: data.produce_unique_code_id,
							name: [data.brand_name, data.model_name, data.color_name, data.memory_name].filter(item => item).join(' '),
							code: data.produce_unique_code
						}
					},
					fail: () => {
						this.$refs.scan.reset();
					}
				});
			},

			submitHandle() {
				let rule = {};
				this.currentItemValue.forEach(val => {
					rule[`item${val}`] = '请填写维修金额';
				});
				this.$refs.form.submit({
					url: this.id ? '/repair/record/edit' : '/repair/record/batchAdd',
					rule: {
						items: '请选择维修项',
						...rule
					},
					dataFormatter: data => {
						return {
							id: this.id,
							produce_unique_code_id: this.codeInfo.id,
							items: JSON.stringify(this.currentItemValue.map(val => {
								return {
									repair_item: val,
									repair_amount: this.itemSum[val]
								}
							})),
							remark: data.remark
						}
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						this.mp.navigateBack(true);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .head {
		padding: .26rem;
		margin-bottom: .2rem;
		font-size: .26rem;
		text-align: center;
		color: #666;
		background: #EFF2FF;

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
			color: #000;
		}
	}
</style>